//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '../services/HttpClientService';
import { Settings } from '../common/Settings';
import { ContactCardDto } from './models';
import { SearchContactsOptions } from './models';
import { ContactCardGroupDto } from './models';
import { ContactConnectAdvancedSearchResultDto } from './models';
import { DictionaryDto } from './models';
import { SearchTitlesOptions } from './models';
import { ServerPagingResult } from './models';
import { BuyerAdvancedSearchGridDto } from './models';
import { SearchParameters } from './models';
import { ContactAdvancedSearchGridDto } from './models';
import { UserTimeZoneDto } from './models';
import { EnumTypeDto } from './models';
import { CountryDto } from './models';
import { AngularPrivateApiSettingsDto } from './models';
import { ClientGridDataDto } from './models';
import { AssociateDto } from './models';
import { ClientDto } from './models';
import { ClientAgentDto } from './models';
import { ClientAttachmentDto } from './models';
import { SampleResponseModel } from './models';
import { ClientNoteDto } from './models';
import { ChangeLogDto } from './models';
import { RepresentationFormDto } from './models';
import { ClientAccountingGeneralDto } from './models';
import { ClientCommissionDto } from './models';
import { ContactLoanoutDto } from './models';
import { ClientParticipantFormDto } from './models';
import { UploadDto } from './models';
import { AttachmentDto } from './models';
import { EmailPreviewDto } from './models';
import { GridDto } from './models';
import { GridV2Dto } from './models';
import { ClientCommissionGridDataDto } from './models';
import { LoanoutGridDataDto } from './models';
import { ParticipantGridDataDto } from './models';
import { AgentIncomeAnalysisPeriodGridDataDto } from './models';
import { InformationViewDto } from './models';
import { ClientEditDto } from './models';
import { ClientAdditionalFormDto } from './models';
import { AssociateGridData } from './models';
import { ClientAssociationDto } from './models';
import { AngularPublicApiSettingsDto } from './models';
import { ErrorDto } from './models';
import { DealExpenseLookupValue } from './models';
import { TVPackageGridDataDto } from './models';
import { TVBookingGridDataDto } from './models';
import { TVPPreCrmGridDataDto } from './models';
import { TVPBookingDto } from './models';
import { TVPPackageDto } from './models';
import { TVPBookingNavDto } from './models';
import { TVPBackendBookingDto } from './models';
import { TVPElementGridDto } from './models';
import { TVPPackageTermAgencyGridDto } from './models';
import { TVPackageNoteDto } from './models';
import { TVPackageNoteDeleteDto } from './models';
import { TVPackageNoteDetailDto } from './models';
import { TVPElementDto } from './models';
import { TVPPackageTermAgencyDto } from './models';
import { TVPckgPaymentDto } from './models';
import { TVPckgChangeLogDto } from './models';
import { PostToNavDto } from './models';
import { TVPMigrateBookingToTmsRequestDto } from './models';
import { TVPPreCrmDto } from './models';
import { TVPPreCrm_assocDto } from './models';
import { TvPckgPreCrmsDto } from './models';
import { UserDetailDto } from './models';
import { UserSettingsDto } from './models';
import { eItineraryView } from './enums';
import { UserGridDto } from './models';
import { UserLoginHistoryDto } from './models';
import { AdminUserDto } from './models';
import { SetUserPasswordDto } from './models';
import { Tv10BookingGridDataDto } from './models';
import { Tv10BookingDto } from './models';
import { Tv10ClientAssocDataDto } from './models';
import { Tv10BuyerAssocDataDto } from './models';
import { Tv10PaymentDataDto } from './models';
import { Tv10AttachmentDataDto } from './models';
import { Tv10NoteDataDto } from './models';

@Injectable({ providedIn: 'root' }) export class SearchController
{
	public GetDefaultBookingAgent() : Observable<ContactCardDto>
	{
		var params = {  };
		return this.httpClientService.get<ContactCardDto>(Settings.createApiUrl('Search/GetDefaultBookingAgent'), params);
		
	}
	public SearchConnectContacts(options: SearchContactsOptions) : Observable<ContactCardDto[]>
	{
		var params = options;
		return this.httpClientService.post<ContactCardDto[]> (Settings.createApiUrl('Search/SearchConnectContacts'), params);
		
	}
	public SearchConnectGroupContacts(options: SearchContactsOptions) : Observable<ContactCardGroupDto[]>
	{
		var params = options;
		return this.httpClientService.post<ContactCardGroupDto[]> (Settings.createApiUrl('Search/SearchConnectGroupContacts'), params);
		
	}
	public SearchConnectContactsAdvanced(options: SearchContactsOptions) : Observable<ContactConnectAdvancedSearchResultDto>
	{
		var params = options;
		return this.httpClientService.post<ContactConnectAdvancedSearchResultDto> (Settings.createApiUrl('Search/SearchConnectContactsAdvanced'), params);
		
	}
	public SearchContacts(options: SearchContactsOptions) : Observable<ContactCardDto[]>
	{
		var params = options;
		return this.httpClientService.post<ContactCardDto[]> (Settings.createApiUrl('Search/SearchContacts'), params);
		
	}
	public SearchTitles(options: SearchTitlesOptions) : Observable<DictionaryDto[]>
	{
		var params = options;
		return this.httpClientService.post<DictionaryDto[]> (Settings.createApiUrl('Search/SearchTitles'), params);
		
	}
	public SearchActiveBuyersAdvanced(searchParameters: SearchParameters) : Observable<ServerPagingResult<BuyerAdvancedSearchGridDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<BuyerAdvancedSearchGridDto>> (Settings.createApiUrl('Search/SearchActiveBuyersAdvanced'), params);
		
	}
	public AdvancedContactSearch(searchParameters: SearchParameters) : Observable<ServerPagingResult<ContactAdvancedSearchGridDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<ContactAdvancedSearchGridDto>> (Settings.createApiUrl('Search/AdvancedContactSearch'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
@Injectable({ providedIn: 'root' }) export class TestController
{
	public Get() : Observable<string[]>
	{
		var params = {  };
		return this.httpClientService.get<string[]>(Settings.createApiUrl('Test/Get'), params);
		
	}
	public GetRevealData() : Observable<string[]>
	{
		var params = {  };
		return this.httpClientService.get<string[]>(Settings.createApiUrl('Test/GetRevealData'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
@Injectable({ providedIn: 'root' }) export class ReferenceController
{
	public GetTimeZones() : Observable<UserTimeZoneDto[]>
	{
		var params = {  };
		return this.httpClientService.get<UserTimeZoneDto[]>(Settings.createApiUrl('Reference/GetTimeZones'), params);
		
	}
	public GetEnumsList() : Observable<EnumTypeDto[]>
	{
		var params = {  };
		return this.httpClientService.get<EnumTypeDto[]>(Settings.createApiUrl('Reference/GetEnumsList'), params);
		
	}
	public GetCountriessDto() : Observable<CountryDto[]>
	{
		var params = {  };
		return this.httpClientService.get<CountryDto[]>(Settings.createApiUrl('Reference/GetCountriessDto'), params);
		
	}
	public GetPrivateSettings() : Observable<AngularPrivateApiSettingsDto>
	{
		var params = {  };
		return this.httpClientService.get<AngularPrivateApiSettingsDto>(Settings.createApiUrl('Reference/GetPrivateSettings'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
@Injectable({ providedIn: 'root' }) export class ClientController
{
	public GetClientsAsync(searchParameters: SearchParameters) : Observable<ServerPagingResult<ClientGridDataDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<ClientGridDataDto>> (Settings.createApiUrl('Client/GetClientsAsync'), params);
		
	}
	public GetClientsDictionaryAsync(search: string) : Observable<DictionaryDto[]>
	{
		var params = { 'search': search };
		return this.httpClientService.get<DictionaryDto[]>(Settings.createApiUrl('Client/GetClientsDictionaryAsync'), params);
		
	}
	public CreateAssocAsync(clientAssociateDto: AssociateDto) : Observable<AssociateDto>
	{
		var params = clientAssociateDto;
		return this.httpClientService.post<AssociateDto> (Settings.createApiUrl('Client/CreateAssocAsync'), params);
		
	}
	public UpdateAssocAsync(dto: AssociateDto) : Observable<AssociateDto>
	{
		var params = dto;
		return this.httpClientService.post<AssociateDto> (Settings.createApiUrl('Client/UpdateAssocAsync'), params);
		
	}
	public DeleteAssocsAsync(dtos: AssociateDto[]) : Observable<AssociateDto>
	{
		var params = dtos;
		return this.httpClientService.post<AssociateDto> (Settings.createApiUrl('Client/DeleteAssocsAsync'), params);
		
	}
	public GetAssocsAsync(clientId: any) : Observable<AssociateDto[]>
	{
		var params = { 'clientId': clientId };
		return this.httpClientService.get<AssociateDto[]>(Settings.createApiUrl('Client/GetAssocsAsync'), params);
		
	}
	public CreateClient(clientDto: ClientDto) : Observable<ClientDto>
	{
		var params = clientDto;
		return this.httpClientService.post<ClientDto> (Settings.createApiUrl('Client/CreateClient'), params);
		
	}
	public CreateClientAgent(dtos: ClientAgentDto[]) : Observable<ClientAgentDto[]>
	{
		var params = dtos;
		return this.httpClientService.post<ClientAgentDto[]> (Settings.createApiUrl('Client/CreateClientAgent'), params);
		
	}
	public UpdateClientAgent(dtos: ClientAgentDto[]) : Observable<ClientAgentDto[]>
	{
		var params = dtos;
		return this.httpClientService.post<ClientAgentDto[]> (Settings.createApiUrl('Client/UpdateClientAgent'), params);
		
	}
	public DeleteClientAgent(dtos: ClientAgentDto[]) : Observable<ClientAgentDto[]>
	{
		var params = dtos;
		return this.httpClientService.post<ClientAgentDto[]> (Settings.createApiUrl('Client/DeleteClientAgent'), params);
		
	}
	public GetClientDetail(id: any) : Observable<ClientDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<ClientDto>(Settings.createApiUrl('Client/GetClientDetail'), params);
		
	}
	public UpdateClientAsync(dto: ClientDto) : Observable<ClientDto>
	{
		var params = dto;
		return this.httpClientService.post<ClientDto> (Settings.createApiUrl('Client/UpdateClientAsync'), params);
		
	}
	public GetSelectedAgentUsers(clientId: any) : Observable<ClientAgentDto[]>
	{
		var params = { 'clientId': clientId };
		return this.httpClientService.get<ClientAgentDto[]>(Settings.createApiUrl('Client/GetSelectedAgentUsers'), params);
		
	}
	public GetClientAttachments(searchParameters: SearchParameters) : Observable<ServerPagingResult<ClientAttachmentDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<ClientAttachmentDto>> (Settings.createApiUrl('Client/GetClientAttachments'), params);
		
	}
	public UpdateClientAttachment(dto: ClientAttachmentDto) : Observable<SampleResponseModel>
	{
		var params = dto;
		return this.httpClientService.post<SampleResponseModel> (Settings.createApiUrl('Client/UpdateClientAttachment'), params);
		
	}
	public DeleteClientAttachment(ids: any[]) : Observable<ClientAttachmentDto[]>
	{
		var params = { 'ids': ids };
		return this.httpClientService.delete(Settings.createApiUrl('Client/DeleteClientAttachment'), params);
		
	}
	public GetClientNotesAsync(searchParameters: SearchParameters) : Observable<ServerPagingResult<ClientNoteDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<ClientNoteDto>> (Settings.createApiUrl('Client/GetClientNotesAsync'), params);
		
	}
	public UpdateClientNoteAsync(dto: ClientNoteDto) : Observable<AssociateDto>
	{
		var params = dto;
		return this.httpClientService.post<AssociateDto> (Settings.createApiUrl('Client/UpdateClientNoteAsync'), params);
		
	}
	public DeleteClientNoteAsync(id: any) : Observable<any>
	{
		var params = { 'id': id };
		return this.httpClientService.delete(Settings.createApiUrl('Client/DeleteClientNoteAsync'), params);
		
	}
	public GetChangeLogGridDataAsync(searchParameters: SearchParameters) : Observable<ServerPagingResult<ChangeLogDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<ChangeLogDto>> (Settings.createApiUrl('Client/GetChangeLogGridDataAsync'), params);
		
	}
	public GetClientIdBySlugAsync(slug: string) : Observable<any>
	{
		var params = { 'slug': slug };
		return this.httpClientService.get<any>(Settings.createApiUrl('Client/GetClientIdBySlugAsync'), params);
		
	}
	public GetClientGeneralRepresentationAsync(clientId: any) : Observable<RepresentationFormDto>
	{
		var params = { 'clientId': clientId };
		return this.httpClientService.get<RepresentationFormDto>(Settings.createApiUrl('Client/GetClientGeneralRepresentationAsync'), params);
		
	}
	public UpdateClientGeneralRepresentationAsync(dto: RepresentationFormDto) : Observable<RepresentationFormDto>
	{
		var params = dto;
		return this.httpClientService.post<RepresentationFormDto> (Settings.createApiUrl('Client/UpdateClientGeneralRepresentationAsync'), params);
		
	}
	public GetContactClientAccountingInformation(contactClientId: any) : Observable<ClientAccountingGeneralDto>
	{
		var params = { 'contactClientId': contactClientId };
		return this.httpClientService.get<ClientAccountingGeneralDto>(Settings.createApiUrl('Client/GetContactClientAccountingInformation'), params);
		
	}
	public CreateAccountingGeneral(dto: ClientAccountingGeneralDto) : Observable<ClientAccountingGeneralDto[]>
	{
		var params = dto;
		return this.httpClientService.post<ClientAccountingGeneralDto[]> (Settings.createApiUrl('Client/CreateAccountingGeneral'), params);
		
	}
	public GetClientCommissionsAsync(clientId: any) : Observable<ClientCommissionDto[]>
	{
		var params = { 'clientId': clientId };
		return this.httpClientService.get<ClientCommissionDto[]>(Settings.createApiUrl('Client/GetClientCommissionsAsync'), params);
		
	}
	public CreateCommission(dto: ClientCommissionDto) : Observable<ClientCommissionDto>
	{
		var params = dto;
		return this.httpClientService.post<ClientCommissionDto> (Settings.createApiUrl('Client/CreateCommission'), params);
		
	}
	public UpdateCommission(dto: ClientCommissionDto) : Observable<ClientCommissionDto>
	{
		var params = dto;
		return this.httpClientService.post<ClientCommissionDto> (Settings.createApiUrl('Client/UpdateCommission'), params);
		
	}
	public DeleteCommissions(ids: any[]) : Observable<any[]>
	{
		var params = ids;
		return this.httpClientService.post<any[]> (Settings.createApiUrl('Client/DeleteCommissions'), params);
		
	}
	public GetLoanoutsAsync(clientId: any) : Observable<ContactLoanoutDto[]>
	{
		var params = { 'clientId': clientId };
		return this.httpClientService.get<ContactLoanoutDto[]>(Settings.createApiUrl('Client/GetLoanoutsAsync'), params);
		
	}
	public CreateLoanoutAsync(dto: ContactLoanoutDto) : Observable<ContactLoanoutDto>
	{
		var params = dto;
		return this.httpClientService.post<ContactLoanoutDto> (Settings.createApiUrl('Client/CreateLoanoutAsync'), params);
		
	}
	public UpdateLoanoutAsync(dto: ContactLoanoutDto) : Observable<ContactLoanoutDto>
	{
		var params = dto;
		return this.httpClientService.post<ContactLoanoutDto> (Settings.createApiUrl('Client/UpdateLoanoutAsync'), params);
		
	}
	public DeleteLoanoutsAsync(dtos: ContactLoanoutDto[]) : Observable<ContactLoanoutDto>
	{
		var params = dtos;
		return this.httpClientService.post<ContactLoanoutDto> (Settings.createApiUrl('Client/DeleteLoanoutsAsync'), params);
		
	}
	public GetClientParticipantsAsync(clientId: any) : Observable<ClientParticipantFormDto[]>
	{
		var params = { 'clientId': clientId };
		return this.httpClientService.get<ClientParticipantFormDto[]>(Settings.createApiUrl('Client/GetClientParticipantsAsync'), params);
		
	}
	public CreateParticipant(dto: ClientParticipantFormDto) : Observable<ClientParticipantFormDto>
	{
		var params = dto;
		return this.httpClientService.post<ClientParticipantFormDto> (Settings.createApiUrl('Client/CreateParticipant'), params);
		
	}
	public UpdateParticipant(dto: ClientParticipantFormDto) : Observable<ClientParticipantFormDto>
	{
		var params = dto;
		return this.httpClientService.post<ClientParticipantFormDto> (Settings.createApiUrl('Client/UpdateParticipant'), params);
		
	}
	public DeleteParticipants(ids: any[]) : Observable<any[]>
	{
		var params = ids;
		return this.httpClientService.post<any[]> (Settings.createApiUrl('Client/DeleteParticipants'), params);
		
	}
	public DeleteClientGridAsync(id: any) : Observable<SampleResponseModel>
	{
		var params = { 'id': id };
		return this.httpClientService.delete(Settings.createApiUrl('Client/DeleteClientGridAsync'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
@Injectable({ providedIn: 'root' }) export class FilesController
{
	public GetPrivateFileUrl(dto: AttachmentDto) : Observable<UploadDto>
	{
		var params = dto;
		return this.httpClientService.post<UploadDto> (Settings.createApiUrl('Files/GetPrivateFileUrl'), params);
		
	}
	public UploadPrivateFile(input: any) : Observable<UploadDto>
	{
		var params = input;
		return this.httpClientService.postWithFile(Settings.createApiUrl('Files/UploadPrivateFile'), params);
		
	}
	public DeletePrivateFile(id: string) : Observable<any>
	{
		var params = { 'id': id };
		return this.httpClientService.delete(Settings.createApiUrl('Files/DeletePrivateFile'), params);
		
	}
	public GetPublicFileUrl(dto: AttachmentDto) : Observable<UploadDto>
	{
		var params = { 'dto': dto };
		return this.httpClientService.get<UploadDto>(Settings.createApiUrl('Files/GetPublicFileUrl'), params);
		
	}
	public GetPublicFileUrlById(id: string) : Observable<UploadDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<UploadDto>(Settings.createApiUrl('Files/GetPublicFileUrlById'), params);
		
	}
	public UploadPublicFile(input: any) : Observable<UploadDto>
	{
		var params = input;
		return this.httpClientService.postWithFile(Settings.createApiUrl('Files/UploadPublicFile'), params);
		
	}
	public DeletePublicFile(id: string) : Observable<any>
	{
		var params = { 'id': id };
		return this.httpClientService.delete(Settings.createApiUrl('Files/DeletePublicFile'), params);
		
	}
	public DownloadDocumentAsStream(dto: AttachmentDto) : Observable<Response>
	{
		var params = dto;
		return this.httpClientService.postOnlyResponse(Settings.createApiUrl('Files/DownloadDocumentAsStream'), params);
		
	}
	public ViewEmlDocument(dto: AttachmentDto) : Observable<EmailPreviewDto>
	{
		var params = dto;
		return this.httpClientService.post<EmailPreviewDto> (Settings.createApiUrl('Files/ViewEmlDocument'), params);
		
	}
	public DownloadEmlAttachment(dto: AttachmentDto) : Observable<Response>
	{
		var params = dto;
		return this.httpClientService.postOnlyResponse(Settings.createApiUrl('Files/DownloadEmlAttachment'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
@Injectable({ providedIn: 'root' }) export class GridController
{
	public GetDealGrid(gridId?: any) : Observable<GridDto>
	{
		var params = { 'gridId': gridId };
		return this.httpClientService.get<GridDto>(Settings.createApiUrl('Grid/GetDealGrid'), params);
		
	}
	public GetDealGridV2(gridId?: any) : Observable<GridV2Dto>
	{
		var params = { 'gridId': gridId };
		return this.httpClientService.get<GridV2Dto>(Settings.createApiUrl('Grid/GetDealGridV2'), params);
		
	}
	public GetBookingGrid(gridId: any) : Observable<GridDto>
	{
		var params = { 'gridId': gridId };
		return this.httpClientService.get<GridDto>(Settings.createApiUrl('Grid/GetBookingGrid'), params);
		
	}
	public GetBookingGridV2(gridId?: any) : Observable<GridV2Dto>
	{
		var params = { 'gridId': gridId };
		return this.httpClientService.get<GridV2Dto>(Settings.createApiUrl('Grid/GetBookingGridV2'), params);
		
	}
	public GetClientGrid(gridId: any) : Observable<GridDto>
	{
		var params = { 'gridId': gridId };
		return this.httpClientService.get<GridDto>(Settings.createApiUrl('Grid/GetClientGrid'), params);
		
	}
	public GetMarketWatchGrid() : Observable<GridDto>
	{
		var params = {  };
		return this.httpClientService.get<GridDto>(Settings.createApiUrl('Grid/GetMarketWatchGrid'), params);
		
	}
	public GetUserGrid(gridId: any) : Observable<GridDto>
	{
		var params = { 'gridId': gridId };
		return this.httpClientService.get<GridDto>(Settings.createApiUrl('Grid/GetUserGrid'), params);
		
	}
	public SetGridAsDefault(gridId: any, gridArea: number) : Observable<any>
	{
		var params = { 'gridId': gridId,'gridArea': gridArea };
		return this.httpClientService.get<any>(Settings.createApiUrl('Grid/SetGridAsDefault'), params);
		
	}
	public UpdateGrid(grid: GridDto) : Observable<GridDto>
	{
		var params = grid;
		return this.httpClientService.post<GridDto> (Settings.createApiUrl('Grid/UpdateGrid'), params);
		
	}
	public AddNewGrid(grid: GridDto) : Observable<GridDto>
	{
		var params = grid;
		return this.httpClientService.post<GridDto> (Settings.createApiUrl('Grid/AddNewGrid'), params);
		
	}
	public UpdateGridV2(grid: GridV2Dto) : Observable<GridV2Dto>
	{
		var params = grid;
		return this.httpClientService.post<GridV2Dto> (Settings.createApiUrl('Grid/UpdateGridV2'), params);
		
	}
	public AddNewGridV2(grid: GridV2Dto) : Observable<GridV2Dto>
	{
		var params = grid;
		return this.httpClientService.post<GridV2Dto> (Settings.createApiUrl('Grid/AddNewGridV2'), params);
		
	}
	public DeleteGrid(id: any) : Observable<SampleResponseModel>
	{
		var params = { 'id': id };
		return this.httpClientService.delete(Settings.createApiUrl('Grid/DeleteGrid'), params);
		
	}
	public GetTVBookingGrid(gridId: any) : Observable<GridDto>
	{
		var params = { 'gridId': gridId };
		return this.httpClientService.get<GridDto>(Settings.createApiUrl('Grid/GetTVBookingGrid'), params);
		
	}
	public GetTVPackagesGrid(gridId: any) : Observable<GridDto>
	{
		var params = { 'gridId': gridId };
		return this.httpClientService.get<GridDto>(Settings.createApiUrl('Grid/GetTVPackagesGrid'), params);
		
	}
	public GetTVPreCrmGrid(gridId: any) : Observable<GridDto>
	{
		var params = { 'gridId': gridId };
		return this.httpClientService.get<GridDto>(Settings.createApiUrl('Grid/GetTVPreCrmGrid'), params);
		
	}
	public GetBuyerGrid(gridId: any) : Observable<GridDto>
	{
		var params = { 'gridId': gridId };
		return this.httpClientService.get<GridDto>(Settings.createApiUrl('Grid/GetBuyerGrid'), params);
		
	}
	public GetTv10BookingGrid(gridId: any) : Observable<GridDto>
	{
		var params = { 'gridId': gridId };
		return this.httpClientService.get<GridDto>(Settings.createApiUrl('Grid/GetTv10BookingGrid'), params);
		
	}
	public GetContactGrid(gridId: any) : Observable<GridDto>
	{
		var params = { 'gridId': gridId };
		return this.httpClientService.get<GridDto>(Settings.createApiUrl('Grid/GetContactGrid'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
@Injectable({ providedIn: 'root' }) export class ClientFinancialController
{
	public GetAccountingGeneralAsync(id: any) : Observable<ClientAccountingGeneralDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<ClientAccountingGeneralDto>(Settings.createApiUrl('ClientFinancial/GetAccountingGeneralAsync'), params);
		
	}
	public UpdateAccountingGeneralAsync(dto: ClientAccountingGeneralDto) : Observable<SampleResponseModel>
	{
		var params = dto;
		return this.httpClientService.post<SampleResponseModel> (Settings.createApiUrl('ClientFinancial/UpdateAccountingGeneralAsync'), params);
		
	}
	public GetClientCommissionsAsync(searchParameters: SearchParameters) : Observable<ServerPagingResult<ClientCommissionGridDataDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<ClientCommissionGridDataDto>> (Settings.createApiUrl('ClientFinancial/GetClientCommissionsAsync'), params);
		
	}
	public GetClientCommissionAsync(id: any) : Observable<ClientCommissionDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<ClientCommissionDto>(Settings.createApiUrl('ClientFinancial/GetClientCommissionAsync'), params);
		
	}
	public UpdateClientCommissionAsync(dto: ClientCommissionDto) : Observable<ClientCommissionDto>
	{
		var params = dto;
		return this.httpClientService.post<ClientCommissionDto> (Settings.createApiUrl('ClientFinancial/UpdateClientCommissionAsync'), params);
		
	}
	public RemoveClientCommissionAsync(ids: any) : Observable<SampleResponseModel>
	{
		var params = { 'ids': ids };
		return this.httpClientService.delete(Settings.createApiUrl('ClientFinancial/RemoveClientCommissionAsync'), params);
		
	}
	public GetClientsLoanoutsAsync(searchParameters: SearchParameters) : Observable<ServerPagingResult<LoanoutGridDataDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<LoanoutGridDataDto>> (Settings.createApiUrl('ClientFinancial/GetClientsLoanoutsAsync'), params);
		
	}
	public GetClientLoanoutAsync(id: any) : Observable<LoanoutGridDataDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<LoanoutGridDataDto>(Settings.createApiUrl('ClientFinancial/GetClientLoanoutAsync'), params);
		
	}
	public UpdateClientLoanoutAsync(dto: LoanoutGridDataDto) : Observable<LoanoutGridDataDto>
	{
		var params = dto;
		return this.httpClientService.post<LoanoutGridDataDto> (Settings.createApiUrl('ClientFinancial/UpdateClientLoanoutAsync'), params);
		
	}
	public RemoveClientLoanoutAsync(id: any) : Observable<SampleResponseModel>
	{
		var params = { 'id': id };
		return this.httpClientService.delete(Settings.createApiUrl('ClientFinancial/RemoveClientLoanoutAsync'), params);
		
	}
	public GetClientsParticipantsAsync(searchParameters: SearchParameters) : Observable<ServerPagingResult<ParticipantGridDataDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<ParticipantGridDataDto>> (Settings.createApiUrl('ClientFinancial/GetClientsParticipantsAsync'), params);
		
	}
	public GetClientParticipantAsync(id: any) : Observable<ClientParticipantFormDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<ClientParticipantFormDto>(Settings.createApiUrl('ClientFinancial/GetClientParticipantAsync'), params);
		
	}
	public UpdateClientParticipantAsync(dto: ClientParticipantFormDto) : Observable<ClientParticipantFormDto>
	{
		var params = dto;
		return this.httpClientService.post<ClientParticipantFormDto> (Settings.createApiUrl('ClientFinancial/UpdateClientParticipantAsync'), params);
		
	}
	public RemoveClientParticipantAsync(id: any) : Observable<SampleResponseModel>
	{
		var params = { 'id': id };
		return this.httpClientService.delete(Settings.createApiUrl('ClientFinancial/RemoveClientParticipantAsync'), params);
		
	}
	public GetClientAgentIncomeAnalisysGridDataAsync(searchParameters: SearchParameters) : Observable<ServerPagingResult<AgentIncomeAnalysisPeriodGridDataDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<AgentIncomeAnalysisPeriodGridDataDto>> (Settings.createApiUrl('ClientFinancial/GetClientAgentIncomeAnalisysGridDataAsync'), params);
		
	}
	public UpdateAgentIncomeAnalysisPeriodAsync(dto: AgentIncomeAnalysisPeriodGridDataDto) : Observable<AgentIncomeAnalysisPeriodGridDataDto>
	{
		var params = dto;
		return this.httpClientService.post<AgentIncomeAnalysisPeriodGridDataDto> (Settings.createApiUrl('ClientFinancial/UpdateAgentIncomeAnalysisPeriodAsync'), params);
		
	}
	public RemoveAgentIncomeAnalysisPeriodAsync(id: any) : Observable<SampleResponseModel>
	{
		var params = id;
		return this.httpClientService.post<SampleResponseModel> (Settings.createApiUrl('ClientFinancial/RemoveAgentIncomeAnalysisPeriodAsync'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
@Injectable({ providedIn: 'root' }) export class ClientGeneralController
{
	public GetClientGeneralInformationViewAsync(id: any) : Observable<InformationViewDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<InformationViewDto>(Settings.createApiUrl('ClientGeneral/GetClientGeneralInformationViewAsync'), params);
		
	}
	public GetClientGeneralRepresentationAsync(id: any) : Observable<RepresentationFormDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<RepresentationFormDto>(Settings.createApiUrl('ClientGeneral/GetClientGeneralRepresentationAsync'), params);
		
	}
	public UpdateClientGeneralRepresentationAsync(dto: RepresentationFormDto) : Observable<SampleResponseModel>
	{
		var params = dto;
		return this.httpClientService.post<SampleResponseModel> (Settings.createApiUrl('ClientGeneral/UpdateClientGeneralRepresentationAsync'), params);
		
	}
	public GetClientAsync(id: any) : Observable<ClientEditDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<ClientEditDto>(Settings.createApiUrl('ClientGeneral/GetClientAsync'), params);
		
	}
	public CreateClientAsync(dto: ClientEditDto) : Observable<SampleResponseModel>
	{
		var params = dto;
		return this.httpClientService.post<SampleResponseModel> (Settings.createApiUrl('ClientGeneral/CreateClientAsync'), params);
		
	}
	public UpdateClientAsync(dto: ClientEditDto) : Observable<SampleResponseModel>
	{
		var params = dto;
		return this.httpClientService.post<SampleResponseModel> (Settings.createApiUrl('ClientGeneral/UpdateClientAsync'), params);
		
	}
	public UpdateAdditionalAsync(dto: ClientAdditionalFormDto) : Observable<SampleResponseModel>
	{
		var params = dto;
		return this.httpClientService.post<SampleResponseModel> (Settings.createApiUrl('ClientGeneral/UpdateAdditionalAsync'), params);
		
	}
	public GetTeamAgentsAsync(id: any) : Observable<ClientAdditionalFormDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<ClientAdditionalFormDto>(Settings.createApiUrl('ClientGeneral/GetTeamAgentsAsync'), params);
		
	}
	public UpdateTeamAgentAsync(clientId: any, ids: any[]) : Observable<SampleResponseModel>
	{
		var params = { 'clientId': clientId,'ids': ids };
		return this.httpClientService.post<SampleResponseModel> (Settings.createApiUrl('ClientGeneral/UpdateTeamAgentAsync'), params);
		
	}
	public GetClientAssociatesAsync(searchParameters: SearchParameters) : Observable<ServerPagingResult<AssociateGridData>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<AssociateGridData>> (Settings.createApiUrl('ClientGeneral/GetClientAssociatesAsync'), params);
		
	}
	public UpdateClientAssociatesAsync(dto: ClientAssociationDto) : Observable<ClientAssociationDto>
	{
		var params = dto;
		return this.httpClientService.post<ClientAssociationDto> (Settings.createApiUrl('ClientGeneral/UpdateClientAssociatesAsync'), params);
		
	}
	public GetClientAssociateAsync(id: any) : Observable<ClientAssociationDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<ClientAssociationDto>(Settings.createApiUrl('ClientGeneral/GetClientAssociateAsync'), params);
		
	}
	public RemoveClientAssociatesAsync(id: any) : Observable<SampleResponseModel>
	{
		var params = id;
		return this.httpClientService.post<SampleResponseModel> (Settings.createApiUrl('ClientGeneral/RemoveClientAssociatesAsync'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
@Injectable({ providedIn: 'root' }) export class PublicController
{
	public GetApiSettings() : Observable<AngularPublicApiSettingsDto>
	{
		var params = {  };
		return this.httpClientService.get<AngularPublicApiSettingsDto>(Settings.createApiUrl('Public/GetApiSettings'), params);
		
	}
	public LogError(error: ErrorDto) : Observable<any>
	{
		var params = error;
		return this.httpClientService.post<any> (Settings.createApiUrl('Public/LogError'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
@Injectable({ providedIn: 'root' }) export class LookupController
{
	public GetTimezoneLu() : Observable<any>
	{
		var params = {  };
		return this.httpClientService.get<any>(Settings.createApiUrl('Lookup/GetTimezoneLu'), params);
		
	}
	public GetCurrencyLu() : Observable<any>
	{
		var params = {  };
		return this.httpClientService.get<any>(Settings.createApiUrl('Lookup/GetCurrencyLu'), params);
		
	}
	public GetDealExpenses() : Observable<DealExpenseLookupValue[]>
	{
		var params = {  };
		return this.httpClientService.get<DealExpenseLookupValue[]>(Settings.createApiUrl('Lookup/GetDealExpenses'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
@Injectable({ providedIn: 'root' }) export class TVPackagesController
{
	public GetTVPackagesAsync(searchParameters: SearchParameters) : Observable<ServerPagingResult<TVPackageGridDataDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<TVPackageGridDataDto>> (Settings.createApiUrl('TVPackages/GetTVPackagesAsync'), params);
		
	}
	public GetTVBookingsAsync(searchParameters: SearchParameters) : Observable<ServerPagingResult<TVBookingGridDataDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<TVBookingGridDataDto>> (Settings.createApiUrl('TVPackages/GetTVBookingsAsync'), params);
		
	}
	public GetTVPreCrmsAsync(searchParameters: SearchParameters) : Observable<ServerPagingResult<TVPPreCrmGridDataDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<TVPPreCrmGridDataDto>> (Settings.createApiUrl('TVPackages/GetTVPreCrmsAsync'), params);
		
	}
	public GetTVPBookingAsync(id: any) : Observable<TVPBookingDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<TVPBookingDto>(Settings.createApiUrl('TVPackages/GetTVPBookingAsync'), params);
		
	}
	public UpdateTVPBookingAsync(dto: TVPBookingDto) : Observable<TVPPackageDto>
	{
		var params = dto;
		return this.httpClientService.post<TVPPackageDto> (Settings.createApiUrl('TVPackages/UpdateTVPBookingAsync'), params);
		
	}
	public DeactivateTVPBookingAsync(ids: any[]) : Observable<any>
	{
		var params = ids;
		return this.httpClientService.post<any> (Settings.createApiUrl('TVPackages/DeactivateTVPBookingAsync'), params);
		
	}
	public ActivateTVPBookingAsync(ids: any[]) : Observable<any[]>
	{
		var params = ids;
		return this.httpClientService.post<any[]> (Settings.createApiUrl('TVPackages/ActivateTVPBookingAsync'), params);
		
	}
	public CheckBookingNavId(navId: string) : Observable<TVPBookingNavDto>
	{
		var params = { 'navId': navId };
		return this.httpClientService.get<TVPBookingNavDto>(Settings.createApiUrl('TVPackages/CheckBookingNavId'), params);
		
	}
	public GetTVPBackendBookingAsync(id: any) : Observable<TVPBackendBookingDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<TVPBackendBookingDto>(Settings.createApiUrl('TVPackages/GetTVPBackendBookingAsync'), params);
		
	}
	public UpdateTVPBackendBookingAsync(dto: TVPBackendBookingDto) : Observable<TVPPackageDto>
	{
		var params = dto;
		return this.httpClientService.post<TVPPackageDto> (Settings.createApiUrl('TVPackages/UpdateTVPBackendBookingAsync'), params);
		
	}
	public GetTVPackageAsync(packageId: any, bookingId: any) : Observable<TVPPackageDto>
	{
		var params = { 'packageId': packageId,'bookingId': bookingId };
		return this.httpClientService.get<TVPPackageDto>(Settings.createApiUrl('TVPackages/GetTVPackageAsync'), params);
		
	}
	public CheckPckgBookingHasTmsPaymentAsync(packageId: any) : Observable<boolean>
	{
		var params = { 'packageId': packageId };
		return this.httpClientService.get<boolean>(Settings.createApiUrl('TVPackages/CheckPckgBookingHasTmsPaymentAsync'), params);
		
	}
	public UpdateTVPPackageAsync(dto: TVPPackageDto) : Observable<TVPPackageDto>
	{
		var params = dto;
		return this.httpClientService.post<TVPPackageDto> (Settings.createApiUrl('TVPackages/UpdateTVPPackageAsync'), params);
		
	}
	public GetTVPPackageElementsGridData(packageId: any) : Observable<TVPElementGridDto[]>
	{
		var params = { 'packageId': packageId };
		return this.httpClientService.get<TVPElementGridDto[]>(Settings.createApiUrl('TVPackages/GetTVPPackageElementsGridData'), params);
		
	}
	public GetTVPPackageTermAgenciesGridData(packageTermId: any) : Observable<TVPPackageTermAgencyGridDto[]>
	{
		var params = { 'packageTermId': packageTermId };
		return this.httpClientService.get<TVPPackageTermAgencyGridDto[]>(Settings.createApiUrl('TVPackages/GetTVPPackageTermAgenciesGridData'), params);
		
	}
	public GetTVPackgesNotesGridData(searchParameters: SearchParameters) : Observable<ServerPagingResult<TVPackageNoteDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<TVPackageNoteDto>> (Settings.createApiUrl('TVPackages/GetTVPackgesNotesGridData'), params);
		
	}
	public UpdateTVPackageNote(dto: TVPackageNoteDto) : Observable<TVPackageNoteDto>
	{
		var params = dto;
		return this.httpClientService.post<TVPackageNoteDto> (Settings.createApiUrl('TVPackages/UpdateTVPackageNote'), params);
		
	}
	public DeleteTVPackageNote(notes: TVPackageNoteDeleteDto[]) : Observable<SampleResponseModel>
	{
		var params = notes;
		return this.httpClientService.post<SampleResponseModel> (Settings.createApiUrl('TVPackages/DeleteTVPackageNote'), params);
		
	}
	public UpdateTVPackageNoteDetail(dto: TVPackageNoteDetailDto) : Observable<TVPackageNoteDetailDto>
	{
		var params = dto;
		return this.httpClientService.post<TVPackageNoteDetailDto> (Settings.createApiUrl('TVPackages/UpdateTVPackageNoteDetail'), params);
		
	}
	public UpdateTVPElementAsync(dto: TVPElementDto) : Observable<TVPElementDto>
	{
		var params = dto;
		return this.httpClientService.post<TVPElementDto> (Settings.createApiUrl('TVPackages/UpdateTVPElementAsync'), params);
		
	}
	public UpdateTVPPackageTermAgencyAsync(dto: TVPPackageTermAgencyDto) : Observable<TVPPackageTermAgencyDto>
	{
		var params = dto;
		return this.httpClientService.post<TVPPackageTermAgencyDto> (Settings.createApiUrl('TVPackages/UpdateTVPPackageTermAgencyAsync'), params);
		
	}
	public GetTVPackageElementAsync(elementId: any) : Observable<TVPElementDto>
	{
		var params = { 'elementId': elementId };
		return this.httpClientService.get<TVPElementDto>(Settings.createApiUrl('TVPackages/GetTVPackageElementAsync'), params);
		
	}
	public GetTVPackageTermAgencyAsync(packageTermAgencyId: any) : Observable<TVPPackageTermAgencyDto>
	{
		var params = { 'packageTermAgencyId': packageTermAgencyId };
		return this.httpClientService.get<TVPPackageTermAgencyDto>(Settings.createApiUrl('TVPackages/GetTVPackageTermAgencyAsync'), params);
		
	}
	public DeactivateTVPackageAsync(ids: any[]) : Observable<any>
	{
		var params = ids;
		return this.httpClientService.post<any> (Settings.createApiUrl('TVPackages/DeactivateTVPackageAsync'), params);
		
	}
	public ActivateTVPackageAsync(ids: any[]) : Observable<any[]>
	{
		var params = ids;
		return this.httpClientService.post<any[]> (Settings.createApiUrl('TVPackages/ActivateTVPackageAsync'), params);
		
	}
	public DeleteTVPackageElementAsync(ids: any[]) : Observable<any[]>
	{
		var params = ids;
		return this.httpClientService.post<any[]> (Settings.createApiUrl('TVPackages/DeleteTVPackageElementAsync'), params);
		
	}
	public DeleteTVPackageAgencyAsync(ids: any[]) : Observable<any[]>
	{
		var params = ids;
		return this.httpClientService.post<any[]> (Settings.createApiUrl('TVPackages/DeleteTVPackageAgencyAsync'), params);
		
	}
	public GetContactOutletTypeId(contactId: number) : Observable<number>
	{
		var params = { 'contactId': contactId };
		return this.httpClientService.get<number>(Settings.createApiUrl('TVPackages/GetContactOutletTypeId'), params);
		
	}
	public GetTVPPaymentsGridData(bookingId: any) : Observable<TVPckgPaymentDto[]>
	{
		var params = { 'bookingId': bookingId };
		return this.httpClientService.get<TVPckgPaymentDto[]>(Settings.createApiUrl('TVPackages/GetTVPPaymentsGridData'), params);
		
	}
	public GetTVPTmsPaymentsGridData(bookingId: any) : Observable<TVPckgPaymentDto[]>
	{
		var params = { 'bookingId': bookingId };
		return this.httpClientService.get<TVPckgPaymentDto[]>(Settings.createApiUrl('TVPackages/GetTVPTmsPaymentsGridData'), params);
		
	}
	public UpdateManagedPaymentAsync(dto: TVPckgPaymentDto) : Observable<TVPckgPaymentDto>
	{
		var params = dto;
		return this.httpClientService.post<TVPckgPaymentDto> (Settings.createApiUrl('TVPackages/UpdateManagedPaymentAsync'), params);
		
	}
	public DeactivateTVPPaymentAsync(ids: any[]) : Observable<any[]>
	{
		var params = ids;
		return this.httpClientService.post<any[]> (Settings.createApiUrl('TVPackages/DeactivateTVPPaymentAsync'), params);
		
	}
	public GetPackageChangeLogGridDataAsync(searchParameters: SearchParameters) : Observable<ServerPagingResult<TVPckgChangeLogDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<TVPckgChangeLogDto>> (Settings.createApiUrl('TVPackages/GetPackageChangeLogGridDataAsync'), params);
		
	}
	public PostToNav(dto: PostToNavDto) : Observable<PostToNavDto>
	{
		var params = dto;
		return this.httpClientService.post<PostToNavDto> (Settings.createApiUrl('TVPackages/PostToNav'), params);
		
	}
	public MigrateBookingToTMS(request: TVPMigrateBookingToTmsRequestDto) : Observable<TVPMigrateBookingToTmsRequestDto>
	{
		var params = request;
		return this.httpClientService.post<TVPMigrateBookingToTmsRequestDto> (Settings.createApiUrl('TVPackages/MigrateBookingToTMS'), params);
		
	}
	public GetTVPrecrm(id: any) : Observable<TVPPreCrmDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<TVPPreCrmDto>(Settings.createApiUrl('TVPackages/GetTVPrecrm'), params);
		
	}
	public PreCrmDataSearch(text: string) : Observable<TVPPreCrm_assocDto[]>
	{
		var params = { 'text': text };
		return this.httpClientService.get<TVPPreCrm_assocDto[]>(Settings.createApiUrl('TVPackages/PreCrmDataSearch'), params);
		
	}
	public PackagesSearch(text: string) : Observable<TVPPreCrm_assocDto[]>
	{
		var params = { 'text': text };
		return this.httpClientService.get<TVPPreCrm_assocDto[]>(Settings.createApiUrl('TVPackages/PackagesSearch'), params);
		
	}
	public UpdatePckgPreCrmAssoc(dto: TvPckgPreCrmsDto) : Observable<TvPckgPreCrmsDto>
	{
		var params = dto;
		return this.httpClientService.post<TvPckgPreCrmsDto> (Settings.createApiUrl('TVPackages/UpdatePckgPreCrmAssoc'), params);
		
	}
	public GetTVPreCrmNotesGridData(searchParameters: SearchParameters) : Observable<ServerPagingResult<TVPackageNoteDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<TVPackageNoteDto>> (Settings.createApiUrl('TVPackages/GetTVPreCrmNotesGridData'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
@Injectable({ providedIn: 'root' }) export class SettingsController
{
	public GetCurrentUser() : Observable<UserDetailDto>
	{
		var params = {  };
		return this.httpClientService.get<UserDetailDto>(Settings.createApiUrl('Settings/GetCurrentUser'), params);
		
	}
	public GetGridPageSize(isMainGrid: boolean, id: any) : Observable<number>
	{
		var params = { 'isMainGrid': isMainGrid,'id': id };
		return this.httpClientService.get<number>(Settings.createApiUrl('Settings/GetGridPageSize'), params);
		
	}
	public SetItineraryLeftBarOpen(isOpen: boolean) : Observable<UserSettingsDto>
	{
		var params = { 'isOpen': isOpen };
		return this.httpClientService.get<UserSettingsDto>(Settings.createApiUrl('Settings/SetItineraryLeftBarOpen'), params);
		
	}
	public SetItineraryRightBarOpen(isOpen: boolean) : Observable<UserSettingsDto>
	{
		var params = { 'isOpen': isOpen };
		return this.httpClientService.get<UserSettingsDto>(Settings.createApiUrl('Settings/SetItineraryRightBarOpen'), params);
		
	}
	public SetItineraryLeftBarPin(isPinned: boolean) : Observable<UserSettingsDto>
	{
		var params = { 'isPinned': isPinned };
		return this.httpClientService.get<UserSettingsDto>(Settings.createApiUrl('Settings/SetItineraryLeftBarPin'), params);
		
	}
	public SetItineraryRightBarPin(isPinned: boolean) : Observable<UserSettingsDto>
	{
		var params = isPinned;
		return this.httpClientService.post<UserSettingsDto> (Settings.createApiUrl('Settings/SetItineraryRightBarPin'), params);
		
	}
	public SetDefaultItinerary(id: any) : Observable<UserSettingsDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<UserSettingsDto>(Settings.createApiUrl('Settings/SetDefaultItinerary'), params);
		
	}
	public SetMainGridPageSize(id: any, pageSize: number) : Observable<UserSettingsDto>
	{
		var params = { 'id': id,'pageSize': pageSize };
		return this.httpClientService.get<UserSettingsDto>(Settings.createApiUrl('Settings/SetMainGridPageSize'), params);
		
	}
	public SetSubGridPageSize(id: any, pageSize: number) : Observable<UserSettingsDto>
	{
		var params = { 'id': id,'pageSize': pageSize };
		return this.httpClientService.get<UserSettingsDto>(Settings.createApiUrl('Settings/SetSubGridPageSize'), params);
		
	}
	public SetDefaultMainGridPageSize(pageSize: number) : Observable<any>
	{
		var params = { 'pageSize': pageSize };
		return this.httpClientService.get<any>(Settings.createApiUrl('Settings/SetDefaultMainGridPageSize'), params);
		
	}
	public SetDefaultSubGridPageSize(pageSize: number) : Observable<any>
	{
		var params = { 'pageSize': pageSize };
		return this.httpClientService.get<any>(Settings.createApiUrl('Settings/SetDefaultSubGridPageSize'), params);
		
	}
	public SetDefaultItineraryView(view: eItineraryView) : Observable<UserSettingsDto>
	{
		var params = { 'view': view };
		return this.httpClientService.get<UserSettingsDto>(Settings.createApiUrl('Settings/SetDefaultItineraryView'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
@Injectable({ providedIn: 'root' }) export class ContactCardController
{
	public CreateContact(contactCards: ContactCardDto[]) : Observable<ContactCardDto[]>
	{
		var params = contactCards;
		return this.httpClientService.post<ContactCardDto[]> (Settings.createApiUrl('ContactCard/CreateContact'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
@Injectable({ providedIn: 'root' }) export class UserController
{
	public GetUsers(parameters: SearchParameters) : Observable<ServerPagingResult<UserGridDto>>
	{
		var params = parameters;
		return this.httpClientService.post<ServerPagingResult<UserGridDto>> (Settings.createApiUrl('User/GetUsers'), params);
		
	}
	public GetUserDetail(id: any) : Observable<UserDetailDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<UserDetailDto>(Settings.createApiUrl('User/GetUserDetail'), params);
		
	}
	public UpdateUserDetail(dto: UserDetailDto) : Observable<UserDetailDto>
	{
		var params = dto;
		return this.httpClientService.post<UserDetailDto> (Settings.createApiUrl('User/UpdateUserDetail'), params);
		
	}
	public DeleteUser(id: any) : Observable<UserDetailDto>
	{
		var params = { 'id': id };
		return this.httpClientService.get<UserDetailDto>(Settings.createApiUrl('User/DeleteUser'), params);
		
	}
	public DeleteUsers(ids: any[]) : Observable<UserDetailDto>
	{
		var params = ids;
		return this.httpClientService.post<UserDetailDto> (Settings.createApiUrl('User/DeleteUsers'), params);
		
	}
	public GetUserLoginHistory(parameters: SearchParameters) : Observable<ServerPagingResult<UserGridDto>>
	{
		var params = parameters;
		return this.httpClientService.post<ServerPagingResult<UserGridDto>> (Settings.createApiUrl('User/GetUserLoginHistory'), params);
		
	}
	public LogUserLoginHistoryAsync(dto: UserLoginHistoryDto) : Observable<any>
	{
		var params = dto;
		return this.httpClientService.post<any> (Settings.createApiUrl('User/LogUserLoginHistoryAsync'), params);
		
	}
	public GetAgents() : Observable<AdminUserDto[]>
	{
		var params = {  };
		return this.httpClientService.get<AdminUserDto[]>(Settings.createApiUrl('User/GetAgents'), params);
		
	}
	public SetUserPassword(dto: SetUserPasswordDto) : Observable<any>
	{
		var params = dto;
		return this.httpClientService.post<any> (Settings.createApiUrl('User/SetUserPassword'), params);
		
	}
	public TestUserLogin() : Observable<any>
	{
		var params = {  };
		return this.httpClientService.get<any>(Settings.createApiUrl('User/TestUserLogin'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
@Injectable({ providedIn: 'root' }) export class Tv10Controller
{
	public GetBookingsAsync(searchParameters: SearchParameters) : Observable<ServerPagingResult<Tv10BookingGridDataDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<Tv10BookingGridDataDto>> (Settings.createApiUrl('Tv10/GetBookingsAsync'), params);
		
	}
	public GetBookingAsync(slug: string) : Observable<Tv10BookingDto>
	{
		var params = { 'slug': slug };
		return this.httpClientService.get<Tv10BookingDto>(Settings.createApiUrl('Tv10/GetBookingAsync'), params);
		
	}
	public UpdateTv10BookingAsync(dto: Tv10BookingDto) : Observable<Tv10BookingDto>
	{
		var params = dto;
		return this.httpClientService.post<Tv10BookingDto> (Settings.createApiUrl('Tv10/UpdateTv10BookingAsync'), params);
		
	}
	public GetTv10BookingClientsAssocDataAsync(bookingId: any) : Observable<Tv10ClientAssocDataDto[]>
	{
		var params = { 'bookingId': bookingId };
		return this.httpClientService.get<Tv10ClientAssocDataDto[]>(Settings.createApiUrl('Tv10/GetTv10BookingClientsAssocDataAsync'), params);
		
	}
	public UpdateTv10BookingClientsAssocDataAsync(dto: Tv10ClientAssocDataDto) : Observable<Tv10ClientAssocDataDto[]>
	{
		var params = dto;
		return this.httpClientService.post<Tv10ClientAssocDataDto[]> (Settings.createApiUrl('Tv10/UpdateTv10BookingClientsAssocDataAsync'), params);
		
	}
	public DeleteTv10ClientAssocAsync(id: any) : Observable<SampleResponseModel>
	{
		var params = { 'id': id };
		return this.httpClientService.get<SampleResponseModel>(Settings.createApiUrl('Tv10/DeleteTv10ClientAssocAsync'), params);
		
	}
	public GetTv10BookingBuyersAssocDataAsync(bookingId: any) : Observable<Tv10BuyerAssocDataDto[]>
	{
		var params = { 'bookingId': bookingId };
		return this.httpClientService.get<Tv10BuyerAssocDataDto[]>(Settings.createApiUrl('Tv10/GetTv10BookingBuyersAssocDataAsync'), params);
		
	}
	public UpdateTv10BookingBuyerAssocDataAsync(dto: Tv10BuyerAssocDataDto) : Observable<Tv10BuyerAssocDataDto[]>
	{
		var params = dto;
		return this.httpClientService.post<Tv10BuyerAssocDataDto[]> (Settings.createApiUrl('Tv10/UpdateTv10BookingBuyerAssocDataAsync'), params);
		
	}
	public DeleteTv10BuyerAssocDataDto(id: any) : Observable<SampleResponseModel>
	{
		var params = { 'id': id };
		return this.httpClientService.get<SampleResponseModel>(Settings.createApiUrl('Tv10/DeleteTv10BuyerAssocDataDto'), params);
		
	}
	public GetTv10PaymentsGridDataAsync(bookingId: any) : Observable<Tv10PaymentDataDto[]>
	{
		var params = { 'bookingId': bookingId };
		return this.httpClientService.get<Tv10PaymentDataDto[]>(Settings.createApiUrl('Tv10/GetTv10PaymentsGridDataAsync'), params);
		
	}
	public CreateTv10PaymentByPaymentGeneratorAsync(dto: Tv10PaymentDataDto[]) : Observable<Tv10PaymentDataDto[]>
	{
		var params = dto;
		return this.httpClientService.post<Tv10PaymentDataDto[]> (Settings.createApiUrl('Tv10/CreateTv10PaymentByPaymentGeneratorAsync'), params);
		
	}
	public UpdateTv10PaymentAsync(dto: Tv10PaymentDataDto) : Observable<Tv10PaymentDataDto[]>
	{
		var params = dto;
		return this.httpClientService.post<Tv10PaymentDataDto[]> (Settings.createApiUrl('Tv10/UpdateTv10PaymentAsync'), params);
		
	}
	public DeactivateTv10PaymentAsync(id: any) : Observable<SampleResponseModel>
	{
		var params = { 'id': id };
		return this.httpClientService.get<SampleResponseModel>(Settings.createApiUrl('Tv10/DeactivateTv10PaymentAsync'), params);
		
	}
	public SendToNavTv10PaymentAsync(id: any) : Observable<SampleResponseModel>
	{
		var params = id;
		return this.httpClientService.post<SampleResponseModel> (Settings.createApiUrl('Tv10/SendToNavTv10PaymentAsync'), params);
		
	}
	public GetTv10AttachmentsGridData(bookingId: any) : Observable<Tv10AttachmentDataDto[]>
	{
		var params = { 'bookingId': bookingId };
		return this.httpClientService.get<Tv10AttachmentDataDto[]>(Settings.createApiUrl('Tv10/GetTv10AttachmentsGridData'), params);
		
	}
	public UpdateTv10AttachmentAsync(dto: Tv10AttachmentDataDto) : Observable<Tv10AttachmentDataDto[]>
	{
		var params = dto;
		return this.httpClientService.post<Tv10AttachmentDataDto[]> (Settings.createApiUrl('Tv10/UpdateTv10AttachmentAsync'), params);
		
	}
	public RemoveTv10AttachmentAsync(id: any) : Observable<SampleResponseModel>
	{
		var params = { 'id': id };
		return this.httpClientService.delete(Settings.createApiUrl('Tv10/RemoveTv10AttachmentAsync'), params);
		
	}
	public GetTv10NotesGridData(bookingId: any) : Observable<Tv10NoteDataDto[]>
	{
		var params = { 'bookingId': bookingId };
		return this.httpClientService.get<Tv10NoteDataDto[]>(Settings.createApiUrl('Tv10/GetTv10NotesGridData'), params);
		
	}
	public UpdateTv10NoteAsync(dto: Tv10NoteDataDto) : Observable<Tv10NoteDataDto[]>
	{
		var params = dto;
		return this.httpClientService.post<Tv10NoteDataDto[]> (Settings.createApiUrl('Tv10/UpdateTv10NoteAsync'), params);
		
	}
	public DeactivateTv10NoteAsync(id: any) : Observable<SampleResponseModel>
	{
		var params = { 'id': id };
		return this.httpClientService.delete(Settings.createApiUrl('Tv10/DeactivateTv10NoteAsync'), params);
		
	}
	public GetTv10ChangeLogGridDataAsync(searchParameters: SearchParameters) : Observable<ServerPagingResult<ChangeLogDto>>
	{
		var params = searchParameters;
		return this.httpClientService.post<ServerPagingResult<ChangeLogDto>> (Settings.createApiUrl('Tv10/GetTv10ChangeLogGridDataAsync'), params);
		
	}
	public DeleteTv10Async(id: any) : Observable<SampleResponseModel>
	{
		var params = { 'id': id };
		return this.httpClientService.delete(Settings.createApiUrl('Tv10/DeleteTv10Async'), params);
		
	}
	constructor (private httpClientService: HttpClientService) { } 
}
